export enum userRoles {
  supervisor = "gogig-campaign-supervisor",
  seeker = "gogig-role-s1",
  operations = "gogig-role-o1",
  admin = "gogig-role-a1",
  external = "gogig-role-audit",
  processor = "gogig-role-processor",
  brand = "gogig-campaign-client",
  agency = "gogig-campaign-agency",
  executor = "gogig-campaign-installer",
  employer = "gogig-role-e1",
}
